import '../style/story.css'

export function Story() {
    return(
        <div className='container'>
            <div className='user-element'>
                <div> <img className='image-user-story' src='http://pm1.narvii.com/7459/929e9e6d2a1b7caad1d64041fd9fb98430d4fa1ar1-400-400v2_00.jpg' alt='user-profile'></img></div>
                <span>Midoriya</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://i.pinimg.com/originals/fd/2b/46/fd2b468f728df2eb4f2dd421cd847525.jpg' alt='user-profile'></img></div>
                <span>Katsuki</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://1.bp.blogspot.com/-HFK63NbiK7s/YOiMKYBRJVI/AAAAAAAADtU/ytoXVS4TmSAKaDcDCvfOyyrO6Z8iqMl5ACLcBGAsYHQ/s736/ae9a0f07e53450000d635e2bbb0507fe.jpg' alt='user-profile'></img></div>
                <span>Ochaco</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://i.pinimg.com/originals/1f/e5/e9/1fe5e9b88fc1fc18b78a7f9757d75b22.png' alt='user-profile'></img></div>
                <span>Tsuyu</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://i.pinimg.com/originals/a0/7a/8f/a07a8f8009f99358368858e553e6b5a3.jpg' alt='user-profile'></img></div>
                <span>Monoma</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://i.pinimg.com/736x/f2/02/44/f202444bcaed2651e33117c991e2d1bb.jpg' alt='user-profile'></img></div>
                <span>Shinsou</span>
            </div>
            <div className='user-element'>
                <div> <img className='image-user-story' src='https://pbs.twimg.com/profile_images/737737354329231360/OhQhufV3_400x400.jpg' alt='user-profile'></img></div>
                <span>MtLady</span>
            </div>
            
        </div>
    )
}